import { backendGet, backendPost, backendPatch } from '../lib/backendClient';

/**
 * Pedidos via backend (unico caminho)
 */
export async function getUserOrders(userId) {
  return await backendGet('/api/orders/my');
}

export async function getOrderById(orderId, userId) {
  return await backendGet(`/api/orders/my/${orderId}`);
}

export async function createOrder(orderData, options = {}) {
  const idempotencyKey = String(options?.idempotencyKey || '').trim();
  const secureOrderData = {
    restaurant_id: orderData.restaurant_id,
    items: orderData.items.map(item => ({
      product_id: item.product_id,
      quantity: item.quantity,
      selected_extras: Array.isArray(item.selected_extras) ? item.selected_extras : []
    })),
    delivery_address: orderData.delivery_address,
    fulfillment_type: orderData.fulfillment_type || 'delivery',
    payment_method: orderData.payment_method,
    cash_change: orderData.cash_change || null,
    voucher: orderData.voucher || null,
    notes: orderData.notes || null,
    idempotency_key: idempotencyKey || undefined,
  };

  const data = await backendPost('/api/orders/secure', secureOrderData, {
    headers: idempotencyKey ? { 'X-Idempotency-Key': idempotencyKey } : undefined,
  });

  return {
    id: data.order_id,
    order_number: data.order_number,
    total: data.total,
    status: data.status,
    ...data
  };
}

export async function cancelOrder(orderId, userId, reason, comment = '') {
  return await cancelUserOrder(orderId, reason, comment);
}

export async function createOrderReview(orderId, payload) {
  return await backendPost(`/api/orders/my/${orderId}/review`, {
    rating: payload?.rating,
    comment: payload?.comment || null,
  });
}

export const ORDER_STATUS_LABELS = {
  pending: 'Aguardando confirmacao',
  confirmed: 'Confirmado',
  preparing: 'Preparando',
  ready: 'Pronto para retirada',
  awaiting_pickup: 'Aguardando retirada',
  out_for_delivery: 'Saiu para entrega',
  delivered: 'Entregue',
  cancelled: 'Cancelado'
};

export const PAYMENT_METHOD_LABELS = {
  credit_card: 'Cart\u00e3o de Cr\u00e9dito',
  debit_card: 'Cart\u00e3o de D\u00e9bito',
  pix: 'PIX',
  cash: 'Dinheiro',
  voucher: 'Voucher',
  card: 'Cart\u00e3o'
};

export async function cancelUserOrder(orderId, reason, comment = '') {
  return await backendPatch(`/api/orders/my/${orderId}/cancel`, {
    reason,
    comment,
  });
}

export async function confirmPickupOrder(orderId) {
  return await backendPatch(`/api/orders/my/${orderId}/pickup-confirm`, {});
}
